
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import gateway from "@/lib/request/gateway";
import Auth from "@/lib/common/auth";
import { QuestionV2Object } from "@/lib/model/exambuilder/question-v2";

@Component({
  components: {
    ModalHeader
  }
})
export default class AddMoreCandidateModal extends Vue {
  @Prop() private isVisible!: boolean;

  @Watch("isVisible")
  onIsVisibleChange() {
    this.formData.ossUrl = "";
  }

  get token() {
    return Auth.token;
  }

  // 弹窗表单
  @Emit("onClose")
  handleClose() {
    this.formData.ossUrl = "";
  }

  // 模版下载
  async downloadExcel() {
    const res = await QuestionV2Object.exportTemplate();
    if (res.code === 0 && res.data.excelUrl) {
      const a = document.createElement("a");
      a.href = res.data.excelUrl;
      a.download = "海纳AI面试录题模板.xlsx";
      a.click();
    }
  }

  // 上传并解析
  formData = {
    ossUrl: ""
  };
  importErrorUrl = "";

  beforeUpload(file: File) {
    const ext = file.name.toLowerCase().split(".");
    const isExcel = ext[ext.length - 1] == "xlsx";

    if (!isExcel) {
      this.$message.error("上传文件只能是 xlsx 格式!");
      return;
    }

    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (!postRes) return;

      gateway.upload(postRes, file).then((res: any) => {
        this.importErrorUrl = "";
        this.formData.ossUrl = res.url;
      });
    });
  }

  handleImport() {
    QuestionV2Object.importByUrl({ excelUrl: this.formData.ossUrl }).then(
      res => {
        if (res.code === 0) {
          if (res.data.errorExcelUrl) {
            this.$message.error("导入失败，请检查文件");
            this.importErrorUrl = res.data.errorExcelUrl;
            return;
          }

          this.$message.success("导入成功");
          this.handleClose();
          this.$emit("confirm");
        }
      }
    );
  }

  handleDownloadError() {
    if (!this.importErrorUrl) return;

    const a = document.createElement("a");
    a.href = this.importErrorUrl;
    a.click();
  }
}
